var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 301,
    viewBox: "0 0 456 301",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.642 129.817C322.476 129.817 284.114 168.171 284.114 215.313C284.115 262.454 322.475 300.806 369.64 300.806C416.807 300.805 455.177 262.455 455.177 215.313C455.177 168.916 418.009 131.033 371.872 129.846C371.754 129.847 371.636 129.844 371.517 129.837C370.893 129.824 370.268 129.817 369.642 129.817ZM317.961 266.969C315.832 264.841 315.831 261.39 317.961 259.263L361.933 215.312L317.961 171.361C315.832 169.234 315.831 165.783 317.961 163.655C320.091 161.526 323.545 161.526 325.675 163.655L369.644 207.605L413.617 163.654C415.746 161.526 419.19 161.526 421.32 163.655C423.452 165.783 423.449 169.235 421.32 171.362L377.353 215.312L421.322 259.262C423.452 261.389 423.449 264.842 421.32 266.969C420.261 268.033 418.859 268.565 417.469 268.565C416.076 268.565 414.676 268.034 413.616 266.969L369.643 223.018L325.675 266.969C324.606 268.033 323.214 268.565 321.824 268.565C320.423 268.565 319.03 268.034 317.961 266.969Z",
    fill: "url(#paint0_linear_2181_93175)",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.5497 105.345C44.6563 105.37 0.822021 149.204 0.822021 203.076C0.823674 256.965 44.6835 300.805 98.5972 300.805L305.051 300.804C310.881 300.804 316.656 300.296 322.329 299.286C293.029 282.727 273.21 251.291 273.21 215.313C273.211 166.689 309.409 126.358 356.287 119.839C340.973 110.423 323.231 105.347 305.069 105.345C303.65 105.345 302.249 104.785 301.226 103.784C300.168 102.744 299.57 101.318 299.589 99.835L299.599 99.3463L299.598 98.6552C299.599 44.7664 255.737 0.924927 201.824 0.924927C147.91 0.924514 104.049 44.7668 104.049 98.6552C104.05 98.8855 104.058 99.1159 104.058 99.3467L104.069 99.8346C104.088 101.318 103.49 102.745 102.439 103.784C101.418 104.785 99.9787 105.345 98.5497 105.345Z",
    fill: "url(#paint1_linear_2181_93175)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2181_93175",
    x1: 284.114,
    y1: 129.817,
    x2: 471.864,
    y2: 150.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA1176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B2BEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2181_93175",
    x1: 0.822021,
    y1: 0.924927,
    x2: 389.049,
    y2: 52.0569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA1176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B2BEC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.38968f6738492540ece022998e6f3681.svg";
export { ForwardRef as ReactComponent };